// extracted by mini-css-extract-plugin
export default {"persons_list":"teamPageSquad_persons_list__6E6MC","team_container":"teamPageSquad_team_container__RJIc7"};